export const POLLING_DELAY = 10000;
